import { alchemyBrand, alchemyDark, alchemyPanel, BREAKPOINTS, theme, Theme, typography } from '@m/alchemy-ui';
import { CommunityDesign } from '../../common/interfaces';
import { getCrowdicityTheme } from './crowdicity-theme';

export const getCommunityTheme = ({ communityColors }: { communityColors?: CommunityDesign }): Theme => {
  // Return default theme early if community colours not yet loaded or not set
  if (!communityColors || !communityColors.button) {
    return theme;
  }

  const crowdicityTheme = getCrowdicityTheme(communityColors);

  const newTheme: Theme = {
    name: 'alchemy',
    breakpoints: BREAKPOINTS,
    defaults: {
      colorScheme: 'alchemyLight',
      palette: 'structural',
      accentPalette: 'interactiveConstructive'
    },
    typography,
    colorSchemes: {
      alchemyLight: crowdicityTheme,
      alchemyDark,
      alchemyPanel,
      alchemyBrand
    }
  };

  return newTheme;
};
